module.exports = __webpack_public_path__ + "img/logo-minidriver.58b679a2.jpg";